<template>
  <div>
    <div class="py-1 bg-dark">
      <div class="container text-right text-white">
        <a href="https://github.com/tomone1202" class="mr-2">
          <i class="fab fa-github-square text-white" aria-hidden="true"></i>
        </a>

        <a href="https://www.facebook.com/tomone1202/">
          <i class="fab fa-facebook-square text-white"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>